// extracted by mini-css-extract-plugin
module.exports = {"root":"antd-pro-pages-home-activity-sign-data-statistic-daily-statistic-daily-detail-list-index-root"};